<template>
  <el-drawer
    title="TransKit"
    @close="$emit('update:visible', false)"
    :visible="visible"
    class="copilot-content"
  >
    <gpt-translator
      ref="gpt"
      :visible="visible"
      :slan="slan"
      :tlan="tlan"
      :staParams="staParams"
    />

    <uniform-check
      :visible="visible"
      :orderId="orderId"
      :qcTaskId="qcTaskId"
      :staParams="staParams"
      @openFilterMode="handleOpenFilterMode"
    />
  </el-drawer>
</template>

<script>
import UniformCheck from './UniformCheck.vue';
import GptTranslator from './GptTranslator.vue';

export default {
  name: 'CopilotPanel',
  props: ['visible', 'orderId', 'qcTaskId', 'slan', 'tlan', 'staParams'],
  components: { UniformCheck, GptTranslator },
  methods: {
    gptTrans(...args) {
      this.$refs.gpt?.toTrans(...args);
    },

    gptPolish(...args) {
      this.$refs.gpt?.toPolish(...args);
    },

    handleOpenFilterMode(args) {
      this.$emit('openFilterMode', args);
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style lang="scss" scope>
.copilot-content {
  .el-drawer__body {
    padding: 15px;
  }
  .el-drawer__header {
    font-weight: bold;
    color: #222;
  }
}
</style>
